import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import EnvoiDuNetCredentialsStore from "../../../../stores/credentials/shipping/edn-credentials-store";

interface IProps {
    credentialsStore: EnvoiDuNetCredentialsStore,
    vGroup: IValidationGroup,
}

const EdnCredentials: React.FC<IProps> = observer(({
           credentialsStore,
           vGroup,
         }) => {
    return (
        <>
            <FormFieldLine
                required
                label='EDN API username'
                key='api_username'
                note='Your EDN API username'
            >
                <Input
                    value={credentialsStore.apiUsername}
                    onChange={credentialsStore.setApiUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='EDN API password'
                key='api_password'
                note='Your EDN API password'
            >
                <Input
                    value={credentialsStore.apiPassword}
                    onChange={credentialsStore.setApiPassword}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='EDN API base URL'
                key='base_api_url'
                note='EDN API base URL, e.g https://test.ews.ysd2.dev1.edn.cloud/api/v1'
            >
                <Input
                    value={credentialsStore.baseApiUrl}
                    onChange={credentialsStore.setBaseApiUrl}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Site ID'
                key='site_id'
                note='Your Site ID'
            >
                <Input
                    value={credentialsStore.siteId}
                    onChange={credentialsStore.setSiteId}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='TMS API key'
                key='tms_api_key'
                note='Your TMS API key'
            >
                <Input
                    value={credentialsStore.tmsApiKey}
                    onChange={credentialsStore.setTmsApiKey}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='TMS API account'
                key='tms_api_account'
                note='Your TMS API account'
            >
                <Input
                    value={credentialsStore.tmsApiAccount}
                    onChange={credentialsStore.setTmsApiAccount}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default EdnCredentials;
